<!--
/**
 * This file includes code from [ngx-duration-picker]
 * (https://github.com/FrancescoBorzi/ngx-duration-picker) licensed under the MIT License.
 * 
 * Copyright (c) 2018 Francesco Borzì
 * See LICENSE file for details.
 */
 -->
<div class="container duration-picker">
  <div class="row text-center">
    <div class="col">
      <a class="btn btn-link" id="dp-hours-up" (click)="hours = hours + config.unitSteps.hours"
        [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </div>

    <div class="col">
      <a class="btn btn-link" id="dp-minutes-up" (click)="minutes = minutes + config.unitSteps.minutes"
        [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </div>

    <!-- <div class="col">
      <a class="btn btn-link" id="dp-seconds-up" (click)="seconds = seconds + config.unitSteps.seconds"
        [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </div> -->
  </div>

  <div class="row text-center mt-2">
    <div class="col">
      <input type="number" placeholder="H" id="dp-hours" [(ngModel)]="hours" [disabled]="disabled">
    </div>

    <div class="col" *ngIf="config.showMinutes">
      <input type="number" placeholder="M" id="dp-minutes" [(ngModel)]="minutes"
        [disabled]="disabled">
    </div>

    <!-- <div class="col">
      <input type="number" placeholder="S" id="dp-seconds" [(ngModel)]="seconds"
        [disabled]="disabled">
    </div> -->
  </div>

  <div class="row text-center mt-2">
    <div class="col">
      <a class="btn btn-link" id="dp-hours-down" (click)="hours = hours - config.unitSteps.hours"
        [ngClass]="{ 'disabled': disabled || hours === 0 }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </div>

    <div class="col">
      <a class="btn btn-link" id="dp-minutes-down" (click)="minutes = minutes - config.unitSteps.minutes"
        [ngClass]="{ 'disabled': disabled || minutes === 0 }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </div>

    <!-- <div class="col">
      <a class="btn btn-link" id="dp-seconds-down" (click)="seconds = seconds - config.unitSteps.seconds"
        [ngClass]="{ 'disabled': disabled || seconds === 0}">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </div> -->
  </div>
</div>